import { render, staticRenderFns } from "./EndDialog.vue?vue&type=template&id=d60c4b48&scoped=true"
import script from "./EndDialog.vue?vue&type=script&lang=js"
export * from "./EndDialog.vue?vue&type=script&lang=js"
import style0 from "./EndDialog.vue?vue&type=style&index=0&id=d60c4b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60c4b48",
  null
  
)

export default component.exports